module.exports = __webpack_public_path__ + "img/leg-left-back.6ace0e4c.png";